import { render, staticRenderFns } from "./ScrollControls.vue?vue&type=template&id=76163380&"
import script from "./ScrollControls.vue?vue&type=script&lang=js&"
export * from "./ScrollControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports